export default "__VITE_ASSET__D1k7C2E1__"